import React from 'react'

export const BackArrowIcon = () => (
  <svg width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <rect
        width="2"
        height="14"
        x="11"
        y="5"
        fill="#AB9F94"
        rx="1"
        transform="matrix(0 -1 -1 0 24 24)"
      />
      <path
        fill="#AB9F94"
        fillRule="nonzero"
        d="M12.707 17.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 01-.03-1.383l5.5-6a1 1 0 011.474 1.352L7.384 11.97l5.323 5.323z"
      />
    </g>
  </svg>
)
